import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import EditWalletItemModal from './EditWalletItemModal';
import PaymentSourceDisplay from '../../../external-components/payments/steps/PaymentSourceDisplay';
import RemoveWalletItemModal from './RemoveWalletItemModal';

const WalletItem = ({ walletItem, payment, actions, onChange, userEmailAddress, userId, walletInUse }) => {
	const [editOpen, setEditOpen] = useState(false);
	const [deleteOpen, setDeleteOpen] = useState(false);

	const _onChange = useCallback(() => {
		setEditOpen(false);
		setDeleteOpen(false);

		if (onChange) onChange();
	}, [onChange]);

	return (
		<Table.Row>
			<Table.Cell>
				<div>{walletItem.nickname}</div>
			</Table.Cell>
			<Table.Cell>
				<PaymentSourceDisplay source={{ fiserv: { ...walletItem } }} />
			</Table.Cell>
			{walletInUse && (
				<Table.Cell>
					{walletItem.inUse && walletItem.inUseByPolicies.map(p => {
						return <div key={p}>{p}</div>;
					})}
				</Table.Cell>
			)}
			<Table.Cell>
				<EditWalletItemModal walletItem={walletItem} open={editOpen} payment={payment} actions={actions} onOpen={() => setEditOpen(true)} onClose={() => setEditOpen(false)} onSave={_onChange} userEmailAddress={userEmailAddress} userId={userId} />
				{!walletItem.inUse && <RemoveWalletItemModal open={deleteOpen} onOpen={() => setDeleteOpen(true)} onClose={() => setDeleteOpen(false)} onDelete={_onChange} walletItem={walletItem} actions={actions} />}
			</Table.Cell>
		</Table.Row>
	);
};

WalletItem.propTypes = {
	walletItem: PropTypes.object.isRequired
};

export default WalletItem;
